(function () {
  function applyResponsiveStyles() {
    const width = window.innerWidth;
    const elements = document.querySelectorAll('[data-tablet-style], [data-desktop-style]');

    elements.forEach((el) => {
      if (width >= 1024 && el.dataset.desktopStyle) {
        // Desktop
        el.setAttribute('style', el.dataset.desktopStyle);
      } else if (width >= 768 && el.dataset.tabletStyle) {
        // Tablet
        el.setAttribute('style', el.dataset.tabletStyle);
      } else {
        // Mobile - restore default style
        if (el.hasAttribute('data-tablet-style')) {
          el.setAttribute('style', 'height: auto;');
        } else if (el.id === 'up-feature-points-title') {
          // For title, apply mobile width setting from data attributes
          const titleAlign = el.getAttribute('data-title-align');
          const titleWidthMobile = el.getAttribute('data-title-width-mobile');
          el.setAttribute(
            'style',
            `text-align: ${titleAlign}; max-width: ${titleWidthMobile}%;`
          );
        } else if (el.id === 'up-feature-points-subtitle') {
          // For subtitle, apply mobile width setting from data attributes
          const subtitleAlign = el.getAttribute('data-subtitle-align');
          const subtitleWidthMobile = el.getAttribute('data-subtitle-width-mobile');
          el.setAttribute(
            'style',
            `text-align: ${subtitleAlign}; max-width: ${subtitleWidthMobile}%;`
          );
        }
      }
    });
  }

  // Apply on load
  applyResponsiveStyles();

  // Apply on resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyResponsiveStyles, 250);
  });
})();